import { FC } from 'react';
import { Icons, Typography } from '../../../../../stories/atoms';
import { formatAmountWithSeparator } from '../../../../../utils/formatter';
import { ColumnFlexContainer, RowFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { IconWithText } from '../../../../../stories/molecules';
import { Colors } from '../../../../../theme';
import { Indicator } from './MetricItem.styles';

type MetricItemProps = {
  icon: Icons;
  indicatorColor: Colors;
  titleText: string;
  descriptionText: string;
} & (
  | { percentValue: number; rawValue?: never; unit?: never }
  | { rawValue: number; unit: string; percentValue?: never }
);

export const MetricItem: FC<MetricItemProps> = ({
  icon,
  indicatorColor,
  titleText,
  descriptionText,
  percentValue,
  rawValue,
  unit,
}) => {
  const displayValue =
    rawValue !== undefined
      ? formatAmountWithSeparator(rawValue, ` ${unit}`, 0)
      : formatAmountWithSeparator(percentValue!, '%');

  return (
    <RowFlexContainer flex={1} alignItems="center" padding={[2, 4]} gap={[2]} hasBorder borderRadius={[4]}>
      <ColumnFlexContainer alignItems="start" style={{ alignSelf: 'flex-start' }}>
        <IconWithText
          label={<Typography type="button">{titleText}</Typography>}
          iconOptions={{
            icon: icon,
            size: 'small',
          }}
          gutterBottom
          spaceBetween="small"
        />

        <Typography type="caption">{descriptionText}</Typography>
      </ColumnFlexContainer>

      <RowFlexContainer flex={1} justifyContent="end">
        <Indicator
          minWidth={[18]}
          height={[18]}
          justifyContent="center"
          alignItems="center"
          borderRadius={[100]}
          backgroundColor="backgroundSelectedDark"
        >
          <Typography type="button" color={indicatorColor}>
            {displayValue}
          </Typography>
        </Indicator>
      </RowFlexContainer>
    </RowFlexContainer>
  );
};
